import React from 'react';
import {HeadingVariant, MarginBottom} from './typography.types';

interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  marginBottom?: MarginBottom;
  variant?: HeadingVariant;
}

const variantClasses: Record<HeadingVariant, string> = {
  [HeadingVariant.PAGE_TITLE]: 'text-2xl sm:text-3xl font-bold',
  [HeadingVariant.SECTION]: 'text-xl font-semibold',
};

const marginClasses: Record<MarginBottom, string> = {
  [MarginBottom.NONE]: 'mb-0',
  [MarginBottom.SM]: 'mb-2',
  [MarginBottom.MD]: 'mb-4',
};

export const Heading: React.FC<HeadingProps> = ({
  children,
  className = '',
  level = 1,
  marginBottom = MarginBottom.MD,
  variant = HeadingVariant.PAGE_TITLE,
}) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  return <Tag className={`${variantClasses[variant]} ${marginClasses[marginBottom]} ${className}`.trim()}>{children}</Tag>;
};
